import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * App Demo page that serves as the entry point for the app demo experience
 * Redirects to the standalone app wizard route
 */
const AppDemo = ({ user, organization }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Redirect if no user or organization
    useEffect(() => {
        if (!user) {
            navigate('/login?redirect=/app-demo');
            return;
        }

        if (!organization) {
            navigate('/onboarding/organization?redirect=/app-demo');
            return;
        }

        // Redirect to the standalone app wizard route
        navigate('/app-wizard');
    }, [user, organization, navigate]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="w-16 h-16 border-4 border-green-200 border-t-green-600 rounded-full animate-spin mx-auto"></div>
                    <p className="mt-4 text-lg font-medium text-gray-700">Loading...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center max-w-md p-6 bg-white rounded-lg shadow-lg">
                    <h2 className="text-2xl font-bold text-red-600 mb-4">Error</h2>
                    <p className="text-gray-700 mb-6">{error}</p>
                    <button 
                        onClick={() => window.location.reload()}
                        className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    // This will not be rendered as we're redirecting in the useEffect
    return null;
};

export default AppDemo; 